import { Component, EventEmitter, LOCALE_ID, NgModule, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocaleModule } from '@farris/ui-locale';

@Component({
  selector: 'ide-switch-button',
  templateUrl: './switch-button.html'
})
export class SwitchButtonComponent {

  @Output() switchView = new EventEmitter<void>(true);

  handleSwitchView(): void {
    this.switchView.emit();
  }

}

@NgModule({
  imports: [CommonModule, LocaleModule],
  exports: [SwitchButtonComponent],
  declarations: [SwitchButtonComponent],
  providers: [
    { provide: LOCALE_ID, useValue: localStorage.getItem('languageCode') || 'zh-CHS' }
  ]
})
export class SwitchButtonModule { }
